import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const getFieldWidth = props => `calc(${props.halfWidth ? '50%' : '100%'} + 40px)`
const FieldErrorView = styled.div`
  width: calc(100% + 40px);
  padding: ${props => (props.error ? '8px 20px 16px 20px' : '8px 20px 8px 20px')};
  margin: ${props => (props.error ? '-8px -20px -16px -20px' : '-8px -20px -8px -20px')};
  box-sizing: border-box;
  background-color: ${props => props.error && props.theme.field.error.background};

  ${breakpoint('portrait')`
    width: ${getFieldWidth};
  `};
`

export default FieldErrorView
